import { render } from "./SavedReports.vue?vue&type=template&id=5de1f24c&scoped=true"
import script from "./SavedReports.vue?vue&type=script&lang=js"
export * from "./SavedReports.vue?vue&type=script&lang=js"

import "./SavedReports.vue?vue&type=style&index=0&id=5de1f24c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de1f24c"]])

export default __exports__